import { cleanContent, moveWidgetsToMainContent } from '@helpers/helpers.js';
import swiperWidget from '@commonWidgets/slider.js';
import countdown from '@commonWidgets/countdown.js';
import masonryCards from '@commonWidgets/masonryCards.js';
import seoWidget from '@commonWidgets/seo.js';
import signup from '@commonWidgets/signupText.js';
import sponsorWidget from '@commonWidgets/sponsors.js';
import gridGallery from '@commonWidgets/gallery.js';

export default function (themes) {
  const { classHome: stateFairHome, idContainer: widgetContainer } = themes[2];
  const isStateFairHome = $('body').hasClass(stateFairHome);

  if (isStateFairHome) {
    $(document).ready(function () {
      cleanContent(stateFairHome);
      moveWidgetsToMainContent(widgetContainer);
      swiperWidget('bbqSwiperWidget', bbqSwiperWidgetOpts);
      countdown('bbqDatesWidget', bbqDatesWidgetOpts);
      masonryCards('bbqTwoCardsWidget', bbqTwoCardsWidgetOpts, 2);
      masonryCards('bbqFourCardsWidget', bbqFourCardsWidgetOpts, 4);
      seoWidget('bbqSeoWidget', bbqSeoWidgetOpts);
      signup('bbqSignup', bbqSignupOpts, true);
      sponsorWidget();
      gridGallery('bbqGridGallery', bbqGridGalleryOpts);
    });
  }
}
